var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirewallManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,11.18c0,4.54-3.41,8.79-8,9.82-4.59-1.03-8-5.28-8-9.82v-3.57c0-.81.49-1.54,1.24-1.85l5-2.05c1.13-.46,2.39-.46,3.51,0l5,2.05c.75.31,1.24,1.04,1.24,1.85v3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.35,11.35h0c-.55.55-1.47.4-1.81-.29l-.41-.82h0c-.71.71-1.11,1.68-1.11,2.68v.1c0,2.15,1.74,3.89,3.89,3.89s3.89-1.74,3.89-3.89h0c0-1.05-.48-2.05-1.3-2.71l-.6-.49c-.61-.49-1.04-1.18-1.21-1.94l-.22-.97h0c-1.04,1.04-1.49,2.53-1.2,3.98,0,0,.09.47.09.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewallManagement);
export default __webpack_public_path__ + "static/media/FirewallManagement.b801ae4885fc895c11c522eb7d319809.svg";
export { ForwardRef as ReactComponent };